import * as actions from "./constants";
import axios from "axios";
const LOGGED_USER_DATA="loggedUserData";
// let loggedUserData;
// try{
//     loggedUserData = JSON.parse(localStorage.getItem(LOGGED_USER_DATA));
// }
// catch (error){
//     loggedUserData = null;
// }
const initialState = {
    user: null,
    error: null,
    authenticated: false,
    loading: false,
    loginAuto: false,
    logOutInProcess: false,
    checkLoginInProcess:false,
    jwtToken: null,
    checkLoginFirstConnection: false,
    firstUrl: window.location.pathname
};

export default (state = initialState,action)=>{
    if (action.type===actions.LOGIN.FAIL){
        state = {
            ...state,
            error: action.payload.error,
            loading: false,
            checkLoginInProcess: false,
            checkLoginFirstConnection: true
        }
    }
    else if (action.type===actions.LOGIN.SUCCESS){
        const user = action.payload.data.item;
        const jwtToken = action.payload.data.jwtToken;
        axios.defaults.headers.Authorization = "Bearer "+jwtToken;
        localStorage.setItem(LOGGED_USER_DATA,JSON.stringify(action.payload.data));
        state = {
            ...state,
            user:user,
            authenticated:true,
            loading: false,
            jwtToken:jwtToken,
            checkLoginInProcess: false,
            checkLoginFirstConnection:true
        }
    }
    else if (action.type === actions.LOGIN.REQUEST){
        state = {
            ...state,
            error: null,
            loading: true,
            loginAuto: action.payload.auto,
            checkLoginInProcess:true
        }
    }
    else if (action.type === actions.LOGIN.INPUT_FIELD_CHANGE){
        state = {
            ...state,
            error: null
        }
    }
    else if (action.type === actions.LOGOUT.REQUEST){
        state = {
            ...state,
            logOutInProcess: true
        }
    }
    else if (action.type===actions.LOGOUT.SUCCESS){
        if (axios.defaults.headers.Authorization){
            delete axios.defaults.headers.Authorization;
        }
        localStorage.removeItem(LOGGED_USER_DATA);
        state = {
            ...initialState,
            checkLoginFirstConnection: true
        }
    }
    else if (action.type===actions.LOGOUT.FAIL){
        //localStorage.removeItem(LOGGED_USER_DATA);
        state = {
            ...state,
            logOutInProcess: false
        }
    }
    else if (action.type === actions.UPDATE_USER){
        const user = action.payload.data.item;
        localStorage.setItem(LOGGED_USER_DATA,JSON.stringify({
            item:user,
            jwtToken: state.jwtToken
        }));
        state = {
            ...state,
            user:user
        }
    }
    else if (action.type === actions.REGISTER.SUCCESS){
        state = {
            ...state,
            error: null,
            registerInProcess:false,
            loginAuto: false
        }
    }
    else if (action.type === actions.REGISTER.REQUEST){
        state = {
            ...state,
            error: null,
            registerInProcess:true
        }
    }
    else if (action.type === actions.REGISTER.FAIL){
        console.log(action.payload.error);
        const isUserNameError = ["username_exists"].includes(action.payload.error);
        const isNickNameError = ["nickname_exists"].includes(action.payload.error);
        state = {
            ...state,
            error: {
                ...state.error,
                username: isUserNameError?"error."+(action.payload.error||"unknown"):undefined,
                nickname: isNickNameError?"error."+(action.payload.error||"unknown"):undefined,
            },
            registerInProcess:false
        }
    }
    return state;
}